import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};

export function UnstyledORContentArea({ children, classes }) {
  return <div className={classes.contentArea}>{children}</div>;
}

UnstyledORContentArea.propTypes = propTypes;

const styles = () => ({
  contentArea: {
    maxWidth: 1300,
    margin: `0 auto`,
  },
});

export default withStyles(styles)(UnstyledORContentArea);
